var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2856 6.09528C12.2856 4.95864 11.834 3.86855 11.0303 3.06483C10.2266 2.2611 9.1365 1.80957 7.99986 1.80957C6.86322 1.80957 5.77313 2.2611 4.9694 3.06483C4.16568 3.86855 3.71415 4.95864 3.71415 6.09528C3.71415 11.0953 1.57129 12.5239 1.57129 12.5239H14.4284C14.4284 12.5239 12.2856 11.0953 12.2856 6.09528Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23608 14.4287C9.1105 14.6452 8.93025 14.8249 8.71338 14.9498C8.49651 15.0747 8.25063 15.1405 8.00036 15.1405C7.75009 15.1405 7.50421 15.0747 7.28734 14.9498C7.07047 14.8249 6.89023 14.6452 6.76465 14.4287",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.3c363a637c1cdd5283ef82d68ea5c64d.svg";
export { ForwardRef as ReactComponent };